import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store';
import './styles/global.css';

import LoginPage from './pages/auth/Login';
import MainPage from './pages/MainPage';
import ExamPage from './pages/exam/ExamPage';
import AdminPage from './pages/admin/AdminPage';
import BoardPage from './pages/board/BoardPage';
import CalendarPage from './pages/calendar/CalendarPage';
import MyPage from './pages/MyPage';
import TrialExam from './pages/TrialExam';  // ✅ 추가

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoggedIn } = useAuthStore();
  // ✅ 로그인 안 됐으면 메인페이지로 이동 + 로그인 모달 자동 오픈
  return isLoggedIn ? <>{children}</> : <Navigate to="/?login=1" replace />;
};

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoggedIn, isAdmin } = useAuthStore();
  if (!isLoggedIn) return <Navigate to="/" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
};

// 앱 시작 시 즉시 토큰 로드 (렌더링 전에 실행)
useAuthStore.getState().init();

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<MainPage />} />
        <Route path="/board/*" element={<PrivateRoute><BoardPage /></PrivateRoute>} />
        <Route path="/calendar/*" element={<PrivateRoute><CalendarPage /></PrivateRoute>} />
        <Route path="/mypage" element={<PrivateRoute><MyPage /></PrivateRoute>} />  {/* ✅ 추가 */}
        <Route path="/trial" element={<TrialExam />} />  {/* ✅ 로그인 불필요 */}
        <Route path="/exam/*" element={<PrivateRoute><ExamPage /></PrivateRoute>} />
        <Route path="/admin/*" element={<AdminRoute><AdminPage /></AdminRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
